/**
 * 计算时间函数封装
 * created by 李智惠 2021-11-4
 */
// 计算日期
let computeDate = function (timestamp) {
    const date = new Date(timestamp);
    return date.getFullYear() + "-" + zeroAdd(date.getMonth() + 1) + "-" + zeroAdd(date.getDate());
}
// 月、日不足10补0
let zeroAdd = function(num) {
    num >= 10 ? num : num = '0' + num;
    return num; 
}
// 计算今天的时间戳和今天周几
let day = new Date(new Date().toLocaleDateString());
let timestamp = day.getTime(); // 今天凌晨0点的时间戳
let weekday = day.getDay();

// 昨天、今天、明天
let today = computeDate(timestamp);
let tomorrow = computeDate(timestamp + 24 * 60 * 60 * 1000);
let aftertomorrow = computeDate(timestamp + 2 * 24 * 60 * 60 * 1000);
// 第15天
let fifteentimestamp = timestamp + 15 * 24 * 60 * 60 * 1000;

// 当前时间
let nowTime = new Date().getFullYear() + '-' + zeroAdd(new Date().getMonth() + 1) + '-' + zeroAdd(new Date().getDate())
            + ' ' + zeroAdd(new Date().getHours()) + ":" + zeroAdd(new Date().getMinutes());

            
let nowTimes = new Date().getFullYear() + '-' + zeroAdd(new Date().getMonth() + 1) + '-' + zeroAdd(new Date().getDate())
+ ' ' + zeroAdd(new Date().getHours()) + ":" + zeroAdd(new Date().getMinutes()) + ":" + zeroAdd(new Date().getSeconds());

// 第一周 周一
weekday == 0 ? weekday = 6 : weekday = (weekday - 1);
let timestamp1 = timestamp - weekday * 24 * 60 * 60 * 1000;
let dateTime11 = computeDate(timestamp1);
// 第一周 周二
let timestamp12 = timestamp1 + 1 * 24 * 60 * 60 * 1000;
let dateTime12 = computeDate(timestamp12);
// 第一周 周三
let timestamp13 = timestamp1 + 2 * 24 * 60 * 60 * 1000;
let dateTime13 = computeDate(timestamp13);
// 第一周 周四
let timestamp14 = timestamp1 + 3 * 24 * 60 * 60 * 1000;
let dateTime14 = computeDate(timestamp14);
// 第一周 周五
let timestamp15 = timestamp1 + 4 * 24 * 60 * 60 * 1000;
let dateTime15 = computeDate(timestamp15);
// 第一周 周六
let timestamp16 = timestamp1 + 5 * 24 * 60 * 60 * 1000;
let dateTime16 = computeDate(timestamp16);
// 第一周 周日
let timestamp17 = timestamp1 + 6 * 24 * 60 * 60 * 1000;
let dateTime17 = computeDate(timestamp17);

// 第二周 周一
let timestamp21 = timestamp1 + 7 * 24 * 60 * 60 * 1000;
let dateTime21 = computeDate(timestamp21);
// 第二周 周二
let timestamp22 = timestamp1 + 8 * 24 * 60 * 60 * 1000;
let dateTime22 = computeDate(timestamp22);
// 第二周 周三
let timestamp23 = timestamp1 + 9 * 24 * 60 * 60 * 1000;
let dateTime23 = computeDate(timestamp23);
// 第二周 周四
let timestamp24 = timestamp1 + 10 * 24 * 60 * 60 * 1000;
let dateTime24 = computeDate(timestamp24);
// 第二周 周五
let timestamp25 = timestamp1 + 11 * 24 * 60 * 60 * 1000;
let dateTime25 = computeDate(timestamp25);
// 第二周 周六
let timestamp26 = timestamp1 + 12 * 24 * 60 * 60 * 1000;
let dateTime26 = computeDate(timestamp26);
// 第二周 周日
let timestamp27 = timestamp1 + 13 * 24 * 60 * 60 * 1000;
let dateTime27 = computeDate(timestamp27);

// 第三周 周一
let timestamp31 = timestamp1 + 14 * 24 * 60 * 60 * 1000;
let dateTime31 = computeDate(timestamp31);
// 第三周 周二
let timestamp32 = timestamp1 + 15 * 24 * 60 * 60 * 1000;
let dateTime32 = computeDate(timestamp32);
// 第三周 周三
let timestamp33 = timestamp1 + 16 * 24 * 60 * 60 * 1000;
let dateTime33 = computeDate(timestamp33);
// 第三周 周四
let timestamp34 = timestamp1 + 17 * 24 * 60 * 60 * 1000;
let dateTime34 = computeDate(timestamp34);
// 第三周 周五
let timestamp35 = timestamp1 + 18 * 24 * 60 * 60 * 1000;
let dateTime35 = computeDate(timestamp35);
// 第三周 周六
let timestamp36 = timestamp1 + 19 * 24 * 60 * 60 * 1000;
let dateTime36 = computeDate(timestamp36);
// 第三周 周日
let timestamp37 = timestamp1 + 20 * 24 * 60 * 60 * 1000;
let dateTime37 = computeDate(timestamp37);

// 第四周 周一
let timestamp38 = timestamp1 + 21 * 24 * 60 * 60 * 1000;
let dateTime38 = computeDate(timestamp38);
// 第四周 周二
let timestamp39 = timestamp1 + 22 * 24 * 60 * 60 * 1000;
let dateTime39 = computeDate(timestamp39);
// 第四周 周三
let timestamp40 = timestamp1 + 23 * 24 * 60 * 60 * 1000;
let dateTime40 = computeDate(timestamp40);
// 第四周 周四
let timestamp41 = timestamp1 + 24 * 24 * 60 * 60 * 1000;
let dateTime41 = computeDate(timestamp41);
// 第四周 周五
let timestamp42 = timestamp1 + 25 * 24 * 60 * 60 * 1000;
let dateTime42 = computeDate(timestamp42);
// 第四周 周六
let timestamp43 = timestamp1 + 26 * 24 * 60 * 60 * 1000;
let dateTime43 = computeDate(timestamp43);
// 第四周 周日
let timestamp44 = timestamp1 + 27 * 24 * 60 * 60 * 1000;
let dateTime44 = computeDate(timestamp44);

// 第五周 周一
let timestamp45 = timestamp1 + 28 * 24 * 60 * 60 * 1000;
let dateTime45 = computeDate(timestamp45);
// 第四周 周二
let timestamp46 = timestamp1 + 29 * 24 * 60 * 60 * 1000;
let dateTime46 = computeDate(timestamp46);
// 第四周 周三
let timestamp47 = timestamp1 + 30 * 24 * 60 * 60 * 1000;
let dateTime47 = computeDate(timestamp47);
// 第四周 周四
let timestamp48 = timestamp1 + 31 * 24 * 60 * 60 * 1000;
let dateTime48 = computeDate(timestamp48);
// 第四周 周五
let timestamp49 = timestamp1 + 32 * 24 * 60 * 60 * 1000;
let dateTime49 = computeDate(timestamp49);
// 第四周 周六
let timestamp50 = timestamp1 + 33 * 24 * 60 * 60 * 1000;
let dateTime50 = computeDate(timestamp50);
// 第四周 周日
let timestamp51 = timestamp1 + 34 * 24 * 60 * 60 * 1000;
let dateTime51 = computeDate(timestamp51);

const timeRange = {
    todaytimestamp: timestamp,
    fifteentimestamp: fifteentimestamp,
    startTimeList: [dateTime11, dateTime21, dateTime31, dateTime38, dateTime45],
    startTime: dateTime11,
    stopTimeList: [dateTime17, dateTime27, dateTime37, dateTime44,dateTime51],
    stopTime: dateTime17,
    week: [dateTime11, dateTime12, dateTime13, dateTime14, dateTime15, dateTime16, dateTime17],
    weekList: [
        [dateTime11, dateTime12, dateTime13, dateTime14, dateTime15, dateTime16, dateTime17],
        [dateTime21, dateTime22, dateTime23, dateTime24, dateTime25, dateTime26, dateTime27],
        [dateTime31, dateTime32, dateTime33, dateTime34, dateTime35, dateTime36, dateTime37],
        [dateTime38, dateTime39, dateTime40, dateTime41, dateTime42, dateTime43, dateTime44],
        [dateTime45, dateTime46, dateTime47, dateTime48, dateTime49, dateTime50, dateTime51],
    ],
    today: today,
    tomorrow: tomorrow,
    aftertomorrow: aftertomorrow,
    nowTime: nowTime,
    nowTimes: nowTimes
}
export default timeRange;
